import { render, staticRenderFns } from "./account-order-point-btn.vue?vue&type=template&id=5c311aa4&scoped=true"
import script from "./account-order-point-btn.vue?vue&type=script&lang=js"
export * from "./account-order-point-btn.vue?vue&type=script&lang=js"
import style0 from "./account-order-point-btn.vue?vue&type=style&index=0&id=5c311aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c311aa4",
  null
  
)

export default component.exports